import { Form, Radio, Space } from 'antd'
import { Typography } from '../../../../../components/Typography'
import { LABELS } from '../../../../../constants'
import { HOSPITAL_OPTIONS } from './constants'
import { ApplicabilityProps } from './types'
import { RowLayout } from 'features/MyCommunity/Vendors/VendorCreation/General/VendorForm/RowLayout'
import { TieredHospitalsSection } from './TieredHospitalsSection/TieredHospitalsSection'

const ApplicabilitySection = ({
  canEditApplicability,
  isTiered,
  applyToHospitals,
  tierOptions
}: ApplicabilityProps) =>
  isTiered ? (
    <>
      <RowLayout title="Applicability">
        <Form.Item
          label={LABELS.APPLY_TO_ALL_HOSPITALS}
          name="apply_to_all_hospitals"
          className="market-share-rebate__hospital-option"
          colon={false}
        >
          <Radio.Group>
            <Space direction="vertical">
              {HOSPITAL_OPTIONS.map((i) => (
                <Radio
                  key={i.label}
                  value={i.value}
                  disabled={!canEditApplicability}
                >
                  <Typography.Body1>{i.label}</Typography.Body1>
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        </Form.Item>
      </RowLayout>
      {!applyToHospitals && (
        <TieredHospitalsSection tierOptions={tierOptions} />
      )}
    </>
  ) : null

export default ApplicabilitySection
